import CryptoJS from 'crypto-js';

// Get encryption keys from environment variables
const getEncryptionKeys = () => {
  const key = '3z8y/B?E(H+MbQeThWmZq4t7w!z%C*F)';
  const iv = "t6w9z\$C&F*J@NcRf";
  
  /* Debug logging for production troubleshooting
  console.log("Environment check:", {
    NODE_ENV: process.env.NODE_ENV,
    hasKey: !!key,
    hasIV: !!iv,
    keyLength: key ? key.length : 0,
    ivLength: iv ? iv.length : 0,
    allEnvVars: Object.keys(process.env).filter(k => k.startsWith('REACT_APP_'))
  });*/
  
  if (!key || !iv) {
    console.error("Encryption keys not found in environment variables", {
      key: key ? "present" : "missing",
      iv: iv ? "present" : "missing",
      availableEnvVars: Object.keys(process.env).filter(k => k.startsWith('REACT_APP_'))
    });
    return null;
  }
  
  return { key, iv };
};

// Decrypt encrypted hex string
export const decrypt = (encryptedHex) => {
  if (!encryptedHex) return "----";

  const keys = getEncryptionKeys();
  if (!keys) {
    console.warn("Cannot decrypt: encryption keys not available");
    return encryptedHex; // Return encrypted text if we can't decrypt
  }

  try {
    const key = CryptoJS.enc.Utf8.parse(keys.key);
    const iv = CryptoJS.enc.Utf8.parse(keys.iv);

    const encryptedWords = CryptoJS.enc.Hex.parse(encryptedHex);

    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: encryptedWords,
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
    
    // Additional validation to ensure decryption was successful
    if (!decryptedString || decryptedString.trim() === '') {
      console.warn("Decryption resulted in empty string, returning original");
      return encryptedHex;
    }
    
    return decryptedString;
  } catch (error) {
    console.error("Decryption failed:", error);
    return encryptedHex; // Return encrypted text if decryption fails
  }
};

// Decrypt an array of strings (useful for options)
export const decryptArray = (encryptedArray) => {
  if (!Array.isArray(encryptedArray)) return [];
  
  return encryptedArray.map(item => {
    if (typeof item === 'string') {
      return decrypt(item);
    }
    return item;
  });
};

// Decrypt question data
export const decryptQuestionData = (questionData) => {
  if (!questionData) return null;
  
  return {
    ...questionData,
    question_text: decrypt(questionData.question_text),
    question_options: decryptArray(questionData.question_options || []),
    question_answer: decrypt(questionData.question_answer),
  };
};
